const handleDropdownPatternOptions = () => {
	const $dropdownOptions = $('.js-dropdown-pattern-options');
	const $dropdownTriggerImage = $dropdownOptions.find('.dropdown__trigger-image');
	const $dropdownTriggerTitle = $dropdownOptions.find('.dropdown__trigger-content h4');

	$dropdownOptions.find('.pattern').on('click', function() {
		const $this = $(this);
		const $patternField = $this.closest('form').find('[name="properties[Pattern]"]');
		const patternName = $this.find('a').data('name');
		const patternNameHandle = $this.find('a').data('pattern');
		const $sliderProductImage = $('.product__slider');
		const slideIndexWithPattern = $sliderProductImage.find('[data-pattern="' + patternNameHandle + '"]').closest('.slick-slide').data('slick-index');

		$patternField.val(patternName).trigger('change');

		$dropdownTriggerImage.html('');

		$this.clone().appendTo($dropdownTriggerImage);

		$dropdownTriggerTitle.text(patternName);

		$this.addClass('is-current').closest('.patterns__item').siblings().find('.pattern').removeClass('is-current');

		$sliderProductImage.slick('slickGoTo', slideIndexWithPattern);
	});
}

handleDropdownPatternOptions();
